<div fxLayout="column" fxLayoutGap="22px" style="padding: 24px;background: rgba(0, 0, 0, 0.86);height: 100%;"
     class="property_container">
  <div fxLayoutAlign="start center" (click)="cancel()" fxLayoutGap="12px" style="cursor: pointer;color: #DEDEDE;">
    <mat-icon style="width:14px;height:14px;font-size:14px">close</mat-icon>
    <span>Close</span>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayoutAlign="row" fxLayoutGap="16px" fxLayoutAlign="start center" style="color: #D9D9D9;">
      <div class="property-name">{{property.unitNum}}</div>
      <app-property-status [status]="property.status"></app-property-status>
      <div *ngIf="property.floorPlan?.urls?.ios || property.floorPlan?.urls?.android" fxLayout="row"
           fxLayoutAlign="center center" class="ar-tag">
        <img src="./assets/images/ar-icon.png">AR
      </div>

    </div>
    <div (click)="editPropertyClick()" fxLayoutAlign="start center" fxLayoutGap="6px"
         style="cursor: pointer;font-size:14px;color:#2142FF;text-decoration-line: underline;">
      <!-- <mat-icon style="width:14px;height:14px;font-size:14px">edit</mat-icon> -->
      <span>Edit</span>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center" style="width: 430px;height:320px">
    <img (click)="openImagePreviewDialog()" [src]="imageUrl" style="object-fit: contain; width: 430px;height:320px"
         *ngIf="imageUrl">
  </div>
  <div>
    <mat-tab-group disableRipple style="margin-top: 15px;">
      <mat-tab label="Details">
        <div fxLayout="column" fxLayoutGap="16px">
          <div fxLayout="row" fxLayoutAlign="space-between" style="color:red;" class="first-attr">
            <div class="property-attr">Config</div>
            <div class="property-value">{{property.bedRoom}}B/{{property.bathRoom}}B/{{property.carParking}}
              C
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">Aspect</div>
            <div class="property-value">
              <ng-container *ngIf="property.aspect">
                {{constants.PROJECT_ASOECT_NAME_MAP[property.aspect] ?
                constants.PROJECT_ASOECT_NAME_MAP[property.aspect].name : '-'}}
              </ng-container>
              <ng-container *ngIf="!property.aspect">
                -
              </ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">Internal area</div>
            <div class="property-value">{{property.internalArea}} m²</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">External area 1</div>
            <div class="property-value">{{(property.externalAreas?.externalArea1 ?
              property.externalAreas.externalArea1 : 0) | number: '1.2-2'}} m²
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">External area 2</div>
            <div class="property-value">{{(property.externalAreas?.externalArea2 ?
              property.externalAreas.externalArea2 : 0) | number: '1.2-2'}} m²
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">Total area</div>
            <div class="property-value">{{property.totalArea}} m²</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="property-attr">Status</div>
            <div class="property-value">
              <app-property-status [status]="property.status"></app-property-status>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="end">
            <div class="property-value" style="font-size: 14px;align-self: flex-end;margin-right: 16px">
              {{property.price / property.totalArea | currency:
              '':'symbol':'1.0-0'}} / m²
            </div>
            <div class="property-attr" style="font-weight: 700;font-size: 24px;">{{property.price|
              currency: '':'symbol':'3.0'}}</div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Agency">
        <mat-list role="list" style="height: 275px;overflow:auto;margin-bottom: 16px"
                  *ngIf="bindAgencyList && bindAgencyList.length>0">
          <mat-list-item role="listitem" *ngFor="let agency of bindAgencyList;">
            <img [src]="SERVER_URL+ 'images/company_'+ agency.id + '/' + agency.logo" class="logo-img">
            <label class="name fc_DEDEDE">{{ agency.NAME }}</label>
          </mat-list-item>
        </mat-list>
        <div *ngIf="bindAgencyList && bindAgencyList.length<=0">
          <div class="no-all">No Allocation</div>
          <div class="all-agencies">All Agencies have permission can sell it</div>
        </div>
        <button mat-flat-button class="edit-allocation" (click)="editAllocation()">Edit allocation</button>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
